<template>
	<div>
		<img v-if="row[ this.field.slug + '_filename' ]" :src="src">
		<span v-else class="no-photo"><span class="fa fa-image-polaroid"></span></span>
	</div>
</template>

<script>
export default {

	props: [ 'row', 'field' ],

	computed: {
		src: function() {
			return this.row[ this.field.slug + '_filepath' ] + 'thumbnail.' + this.row[ this.field.slug + '_filename' ];
		}
	},
};
</script>
